import { isAxiosError } from 'axios';

const isNetworkError = (error: unknown) =>
  isAxiosError(error) && !error.response && error.code !== 'ERR_CANCELED';

export default isNetworkError;
